module.exports = __webpack_public_path__ + "assets/images/CHF50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CHF50.png
// module id = 1341
// module chunks = 1